import { Cta as HygraphCTAProps } from '@/lib/types';

import CTA from '@/components/cta';

import CTATransformer from '@/hygraph/transformers/cta.transformer';

export default function CTARenderer(hygraphCTAProps: HygraphCTAProps) {
  const props = CTATransformer(hygraphCTAProps);
  if (!props) return <></>;

  return <CTA {...props} />;
}
